import script from "./BroadcastRegistrationFieldsEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./BroadcastRegistrationFieldsEditor.vue?vue&type=script&setup=true&lang=js"

import "./BroadcastRegistrationFieldsEditor.vue?vue&type=style&index=0&id=53c40ac8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53c40ac8"]])

export default __exports__